import React from 'react';
import Switch from '../../../../../../../Shared/Switch';
import { StyledQuestionFieldContainer } from '../../styles';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const StructuredInputSwitch = ({ checked, onChange }: Props) => (
  <StyledQuestionFieldContainer>
    <Switch
      label="Has structured input"
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
      checked={checked}
      disabled={false}
      reverseOrder={false}
    />
  </StyledQuestionFieldContainer>
);

export default StructuredInputSwitch;
